//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'Lifestyle_FightGraph',
  props: {
    id: {
      type: String,
      default: '',
    },
    pos: {
      type: String,
      default: '20%',
    },
    title: {
      type: String,
      default: '',
    },
    minLabel: {
      type: String,
      default: '',
    },
    maxLabel: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'https://images.pexels.com/photos/2280842/pexels-photo-2280842.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
    },
  },
};
